export function isObject(value: any): boolean {
  return Object.prototype.toString.apply(value) === "[object Object]";
}

interface DeserializedObject {
  [key: string]: any;
}

export function deserialize<Expected extends Record<string, any>>(
  obj: Record<string, any>
): Expected {
  const result: DeserializedObject = {};

  // remove undefined values
  const normalizedObject = JSON.parse(JSON.stringify(obj));

  for (const key in normalizedObject) {
    try {
      result[key] = JSON.parse(normalizedObject[key]);
    } catch (e) {
      result[key] = normalizedObject[key];
    }
  }
  return result as Expected;
}

export function mergeDeep(primary: any, secondary: any): any {
  if (typeof primary !== "object" || typeof secondary !== "object") {
    return secondary;
  }

  const target = { ...primary };

  for (const key in secondary) {
    if (secondary[key] === undefined) {
      continue;
    }

    if (Object.prototype.hasOwnProperty.call(secondary, key)) {
      if (
        Object.prototype.hasOwnProperty.call(primary, key) &&
        typeof primary[key] === "object" &&
        typeof secondary[key] === "object"
      ) {
        target[key] = mergeDeep(primary[key], secondary[key]);
      } else {
        target[key] = secondary[key];
      }
    }
  }

  return target;
}
